import { Box, Button, Layer, Text } from "grommet";
import React from "react";
import "./InfoPopUp.css";
import StandardColors from "../StandardColors";
import { logoutSession, saveDeviceToken } from "./CheckMultiLogin";
import { observer } from "mobx-react";
import { useStore } from "../../Hooks/useStore";
import { Auth } from "aws-amplify";
import { useUser } from "../../components/main/context/User/UserContext";

function SameUserLoginModal() {
  const { rootStore } = useStore();
  const { user, setUser } = useUser();

  // yes button handler
  const onYesBtnClick = async () => {
    rootStore.userStore.handleSameloginUserModal(false);
    // // save new device id
    await saveDeviceToken();

    let userAttribute = await Auth.currentAuthenticatedUser();
    console.log("userAttribute", userAttribute.attributes);

    let rolename;
    let uRole = rootStore.userStore.getURole;
    if (uRole == "") {
      rolename = rootStore.userStore.getRoleArr[0].rolename;
    }
    if (uRole == "admin1") {
      rolename = "SUPERADMIN";
    } else if (uRole == "admin") {
      rolename = "ADMIN";
    } else if (uRole == "ems") {
      rolename = "EMS";
    }

    const userinformation = {
      username: userAttribute.username,
      roleLabel: rolename,
      ...userAttribute.attributes,
    };
    setUser(userinformation);
    localStorage.setItem("userinfo", JSON.stringify(userinformation));

    if (!userAttribute.attributes.hasOwnProperty("email_verified")) {
      if (!userAttribute.attributes.email_verified) {
        rootStore.userStore.setStep(5);
        return;
      }
    } else {
      const session = await Auth.currentSession();
      const accessToken = session.getAccessToken().getJwtToken();
      console.log("accessToken", accessToken);
      rootStore.userStore.setSession(accessToken);
    }
  };

  // cancel button handler
  const onCancelBtnClick = async () => {
    // logout user
    rootStore.userStore.handleSameloginUserModal(false);
    rootStore.userStore.setSession("");
    await logoutSession(rootStore);
  };

  const styles = {
    container: {
      overflow: "hidden",
      width: 600,
      paddingBottom: 30,
    },
    header: {
      padding: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "12px 12px 0px 0px",
      background: "#E9F2FF",
      color: "#4B628A",
      fontFamily: "Inter",
      fontSize: 20,
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "26px",
    },
    content: {
      padding: 30,
      textAlign: "center",
      color: "#4B628A",
      fontFamily: "Inter",
      fontSize: 16,
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "22px",
    },
    newLineText: {
        textAlign: "center",
        color: "#4B628A",
        fontFamily: "Inter",
        fontSize: 16,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "22px",
        display: 'block'
    },
    btn1: {
      padding: "14px 49px",
      color: "#fff",
      borderRadius: 10,
      borderColor: "#357EFF",
      background: '#357EFF',
      marginLeft: 14,
      marginTop: 0
    },
    btn2: {
        padding: "14px 49px",
        color: "#fff",
        borderRadius: 10,
        borderColor: "#357EFF",
        background: '#fff',
        color: '#357EFF',
        marginTop: 0
      },
  };

  return (
    <Layer style={{ borderRadius: "12px" }}>
      <Box style={styles.container}>
        <Box style={styles.header}>Multiple logins detected</Box>
        <Text style={styles.content}>Multiple logins detected with this username,do you want to log<Text style={styles.newLineText}>out of other devices?</Text></Text>
        <Box direction="row" align="center" justify="center">
          <Button
           style={styles.btn2}
            label="Yes"
            onClick={onYesBtnClick}
            className="btn"
          />
          <Button
            style={styles.btn1}
            label="Cancel"
            onClick={onCancelBtnClick}
            className="btn"
          />
        </Box>
      </Box>
    </Layer>
  );
}

export default observer(SameUserLoginModal);
